import { memo, useCallback } from "react";

import { Button } from "ui/components/Button/Button";

import { WarehouseWorkingHoursPresetButtonProps } from "../types";

/** Gumb predloška radnog vremena: jednim klikom postavi cijeli tjedan. */
const WarehouseWorkingHoursPresetButton: React.FC<WarehouseWorkingHoursPresetButtonProps> = ({ preset, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(preset);
  }, [preset, onClick]);

  return (
    <Button variant="outlined" size="small" onClick={handleClick}>
      {preset.label}
    </Button>
  );
};

export default memo(WarehouseWorkingHoursPresetButton);
